import Loadable from 'app/components/Loadable';
import { lazy } from 'react';

const AllmembersGSC = Loadable(lazy(() => import('./AllmembersGSC')));
const Importsports = Loadable(lazy(() => import('./Importsports')));
const Userreports = Loadable(lazy(() => import('./Userreports')));
const ClubAllAccess = Loadable(lazy(() => import('./ClubAllAccess')));
const Deletionrequests = Loadable(lazy(() => import('./Deletionrequests')));
const Businesses = Loadable(lazy(() => import('./Businesses')));
const Sponsors = Loadable(lazy(() => import('./Sponsors')));
const Vouchusers = Loadable(lazy(() => import('./VouchUsers')));

const pagesRoutes = [
  { path: '/pages/allmembersGSC', element: <AllmembersGSC /> },
  { path: '/pages/importsports', element: <Importsports /> },
  { path: '/pages/userreports', element: <Userreports /> },
  { path: '/pages/cluballaccess', element: <ClubAllAccess /> },
  { path: '/pages/deletionrequests', element: <Deletionrequests /> },
  { path: '/pages/businesses', element: <Businesses /> },
  { path: '/pages/sponsors', element: <Sponsors /> },
  { path: '/pages/vouchusers', element: <Vouchusers /> },
];

export default pagesRoutes;
